module.exports = __webpack_public_path__ + "static/008031-c240eb749672be7d0d1aefda404a1edd.jpg";